var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumber3Gray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_710_995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0102 71.2C27.1435 71.2 22.3102 70.5667 17.5102 69.3C12.7102 67.9667 8.64349 66.1 5.31016 63.7L11.6102 51.3C14.2768 53.2333 17.3768 54.7667 20.9102 55.9C24.4435 57.0333 28.0102 57.6 31.6102 57.6C35.6768 57.6 38.8768 56.8 41.2102 55.2C43.5435 53.6 44.7102 51.4 44.7102 48.6C44.7102 45.9333 43.6768 43.8333 41.6102 42.3C39.5435 40.7667 36.2102 40 31.6102 40H24.2102V29.3L43.7102 7.2L45.5102 13H8.81016V-4.76837e-06H57.8102V10.5L38.4102 32.6L30.2102 27.9H34.9102C43.5102 27.9 50.0102 29.8333 54.4102 33.7C58.8102 37.5667 61.0102 42.5333 61.0102 48.6C61.0102 52.5333 59.9768 56.2333 57.9102 59.7C55.8435 63.1 52.6768 65.8667 48.4102 68C44.1435 70.1333 38.6768 71.2 32.0102 71.2Z",
    fill: "url(#paint0_linear_710_995)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_710_995",
    x: 0.310547,
    y: 0,
    width: 65.6992,
    height: 81.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_710_995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_710_995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_995",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707070",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3Gray);
export default __webpack_public_path__ + "static/media/number_3_gray.12badd336b505dbf0af467ce3a73a4cb.svg";
export { ForwardRef as ReactComponent };